import { render } from "./CheckColor.vue?vue&type=template&id=6944a62d"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/CheckColor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6944a62d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6944a62d', __exports__)) {
    api.reload('6944a62d', __exports__)
  }
  
  module.hot.accept("./CheckColor.vue?vue&type=template&id=6944a62d", () => {
    api.rerender('6944a62d', render)
  })

}


export default __exports__